import { useState } from 'react'

interface Props {
  onLogin: (token: string) => Promise<void>
  error: string
  loading: boolean
}

export function AuthOverlay({ onLogin, error, loading }: Props) {
  const [token, setToken] = useState('')

  const handleSubmit = () => onLogin(token)

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(1,87,98,.96)',
      zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--card)', borderRadius: 16, padding: '40px 44px',
        maxWidth: 400, width: '90%', textAlign: 'center',
      }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--t3)', marginBottom: 24 }}>
          FEMM · IFSD Network · Admin
        </div>
        <h2 style={{ fontSize: 20, fontWeight: 500, color: 'var(--t1)', marginBottom: 6 }}>Research Dashboard</h2>
        <p style={{ fontSize: 12, color: 'var(--t3)', marginBottom: 24, lineHeight: 1.5 }}>
          Enter your admin access token to load live data from the submission database.
        </p>
        <input
          type="password"
          placeholder="Admin token"
          autoComplete="off"
          value={token}
          onChange={e => setToken(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          style={{
            width: '100%', padding: '10px 14px', border: '1.5px solid var(--border)', borderRadius: 8,
            fontFamily: 'var(--f-mono)', fontSize: 13, color: 'var(--t1)', background: 'var(--page)',
            outline: 'none', marginBottom: 12, boxSizing: 'border-box',
          }}
        />
        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            width: '100%', padding: 11, background: 'var(--teal)', color: '#fff', border: 'none',
            borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: 'var(--f-disp)',
          }}
        >
          {loading ? 'Loading…' : 'Access Dashboard →'}
        </button>
        {error && (
          <div style={{ fontSize: 11, color: 'var(--rose)', marginTop: 8 }}>{error}</div>
        )}
      </div>
    </div>
  )
}
